import {
  FETCH_TASKS,
  FETCH_TASKS_SUCCESS,
  FETCH_TASKS_FAILED,
  ACCEPT_TASK,
  CANCEL_TASK,
} from "../store/types";
import store from "../store/store";
import { getSupabase } from "../config/configureSupabase";

let supabaseTasksChannel = null;

const mapRouteToTask = (r) => {
  const origin = typeof r.origin === 'object' ? r.origin : { add: r.origin || '' };
  const dest = typeof r.destination === 'object' ? r.destination : { add: r.destination || '' };
  return {
    ...r,
    id: r.id,
    booking_id: r.id,
    reference: r.reference_code || r.id?.substring(0, 8),
    pickup: origin,
    pickupAddress: origin?.add || origin?.address || '',
    drop: dest,
    dropAddress: dest?.add || dest?.address || '',
    driver: r.driver_id,
    driver_id: r.driver_id,
    vehicle_id: r.vehicle_id,
    status: r.status,
    estimate: r.total_distance_km ? (Number(r.total_distance_km) * 2.5).toFixed(2) : 0,
    estimateDistance: r.total_distance_km || 0,
    estimateTime: r.total_duration_min ? r.total_duration_min * 60 : 0
  };
};

export const fetchTasks = () => (dispatch) => {
  const supabase = getSupabase();
  const userInfo = store.getState().auth?.profile;

  if (!supabase || !userInfo) {
    dispatch({
      type: FETCH_TASKS_FAILED,
      payload: store.getState().languagedata?.defaultLanguage?.no_tasks || 'No tasks',
    });
    return;
  }

  dispatch({
    type: FETCH_TASKS,
    payload: null,
  });

  const loadSupabaseTasks = async () => {
    try {
      let query = supabase.from('routes').select('*').in('status', ['PENDING', 'NEW']).order('created_at', { ascending: false });
      if (userInfo.tenant_id) {
        query = query.eq('tenant_id', userInfo.tenant_id);
      }
      const { data, error } = await query;
      if (!error && data) {
        const arr = data.map(mapRouteToTask);
        dispatch({
          type: FETCH_TASKS_SUCCESS,
          payload: arr,
        });
      }
    } catch (err) {
      console.warn('fetchTasks supabase error:', err);
      dispatch({
        type: FETCH_TASKS_FAILED,
        payload: store.getState().languagedata?.defaultLanguage?.no_tasks || 'No tasks',
      });
    }
  };

  loadSupabaseTasks();

  if (!supabaseTasksChannel) {
    supabaseTasksChannel = supabase
      .channel('public:routes:tasks')
      .on('postgres_changes', { event: '*', schema: 'public', table: 'routes' }, () => {
        loadSupabaseTasks();
      })
      .subscribe();
  }
};

export const acceptTask = (task) => async (dispatch) => {
  const supabase = getSupabase();
  const userInfo = store.getState().auth?.profile;
  const uid = userInfo?.uid || userInfo?.id;

  if (supabase && task?.id && uid) {
    try {
      const { error } = await supabase.from('routes').update({
        status: 'ASSIGNED',
        driver_id: uid,
        updated_at: new Date().toISOString()
      }).eq('id', task.id);

      if (!error) {
        const driverLocation = store.getState().gpsdata?.location;
        if (driverLocation?.lat && driverLocation?.lng && userInfo?.tenant_id) {
          await supabase.from('route_tracking').insert({
            tenant_id: userInfo.tenant_id,
            route_id: task.id,
            vehicle_id: task.vehicle_id || null,
            lat: driverLocation.lat,
            lng: driverLocation.lng,
            heading: driverLocation.heading || 0,
            speed: driverLocation.speed || 0
          });
        }

        dispatch({
          type: ACCEPT_TASK,
          payload: { task: task },
        });
      }
    } catch (e) {
      console.warn('acceptTask supabase error:', e);
    }
  }
};

export const cancelTask = (bookingId) => async (dispatch) => {
  const supabase = getSupabase();
  const userInfo = store.getState().auth?.profile;
  const uid = userInfo?.uid || userInfo?.id;

  if (supabase && bookingId) {
    try {
      await supabase.from('routes').update({
        status: 'PENDING',
        driver_id: null,
        updated_at: new Date().toISOString()
      }).eq('id', bookingId);

      dispatch({
        type: CANCEL_TASK,
        payload: { uid: uid, bookingId: bookingId },
      });
    } catch (e) {
      console.warn('cancelTask supabase error:', e);
    }
  }
};
